var exports = {
  "Wv": "PopoverTrigger__5U6yV6",
  "MH": "PopoverHeading__zXV1Bx",
  "DI": "PopoverHeader__Mbp-wC",
  "Z3": "PopoverDivider__7SbkE5",
  "vl": "ConflictedFilesList__QS_uMZ",
  "Iz": "ConflictPath__OFq98x",
};

module.exports = exports;
